module.exports = __webpack_public_path__ + "img/weather_star.fd14893d.png";